//https://material-ui.com/components/bottom-navigation/

import React  from 'react'; 
import { makeStyles } from '@mui/styles';
import {   Link , useLocation} from 'react-router-dom'

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';

 

// import BarChart from '@mui/icons-material/BarChart';

//icons
// https://mui.com/material-ui/material-icons/

 //Google analytics
//https://stackoverflow.com/questions/49279820/adding-google-analytics-to-react
//import ReactGA from 'react-ga';


// import LocalCafeIcon from '@mui/icons-material/LocalCafe';
// import FavoriteIcon from '@mui/icons-material/Favorite';

import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import ListAltIcon from '@mui/icons-material/ListAlt';
import EditNoteIcon from '@mui/icons-material/EditNote';
import BarChartIcon from '@mui/icons-material/BarChart';

import AnalyticsIcon from '@mui/icons-material/Analytics';
  
//import LocationOnIcon from '@mui/icons-material/LocationOn';
//import Badge from '@mui/material/Badge';

//import { FunctionsRounded } from '@mui/icons-material';
//import { red } from '@mui/material/colors';

const useStyles = makeStyles({
  root: {
   // width: 968,
    
  },
  stickToBottom: {
    width: '100%',
    zIndex:2147483647
    // position: 'fixed',
    // bottom: 0,
  },
  
  selected:{ 
     backgroundColor:'#DBF3FD',
  },
});

export default function FooterBottomNavigation() {
  const classes = useStyles();

 
  const [value, setValue] = React.useState(0);
  const [active, setActive] = React.useState("");


//https://stackoverflow.com/questions/45373742/detect-route-change-with-react-router
const location = useLocation();
React.useEffect(() => {

  function setStateA (state){
    setActive(state);
   };


   function URL2Title(url){
if(url.includes("/profile/")){
  return "Profile"
}

     let title="ACTIVE RESEARCH";
     switch(url) {
      case "/":
        title="ACTIVE RESEARCH";
        break;
      case "/search":
        title="Search";
        break;
      // case "/invitations":
      //   title="Invitations";
      //   break;
      // case "/myinvites":
      //     title="My invitations";
      //     break;

         case "/mylikes":
              title="My Likes";
              break;

          case "/dataanalytics":
              title="dataanalytics";
              break; 
         case "/whosviewedme":
              title="Who's viewed me";
              break;   

       case "/inbox":
            title="Inbox";
            break;

     
         case "/editprofile":
             title="Edit profile";
             break;  
         case "/accountsettings":
             title="Account settings";
              break;  
        case "/membership":
                title="Membership";
                 break;  
        case "/pricing":
         title="Pricing";
         break;            
         case "/about-us":
          title="About us";
          break;                   
          case "/safety":
            title="Safety";
            break; 
            case "/cookie-policy":
              title="Cookie policy";
              break; 
           case "/privacy-policy":
              title="Privacy policy";
              break;             
            case "/terms-of-service":
                title="Terms of service";
                break; 
                case "/refund-policy":
                  title="Refund policy";
                  break;    
          case "/contact":
                  title="Contact";
                  break;   
                  case "/support":
                    title="Support";
                    break;   
      case "/login":
            title="Login";
            break;   
         case "/signup":
              title="Signup";
              break;    
        case "/restorepassword":
                title="Restore password";
                break;                                                   
      default:
        title="ACTIVE RESEARCH";
    }
     
    return title;
   }//end function URL2Title(url){

 //for GTAG
 //https://stackoverflow.com/questions/49322314/react-spa-gtm-analytics-react-helmet-previous-page-title
 //EXPLAIND !!! https://www.bounteous.com/insights/2018/03/30/single-page-applications-google-analytics/
 //console.log('Location changed ' + window.location.pathname); 
const firePageViewEvent = () => {
  setTimeout(() => {
      //console.log("Pageview event fired (from tracking script)"); 

      if (window && window._tfa) {
        window._tfa = window._tfa || [];
        window._tfa.push({notify: 'event', name: 'page_view', id: 1388859});         
      }


      if (window && window.dataLayer) {
        let urlPath = window.location.pathname + window.location.search;
        let urlTitle=URL2Title(urlPath) ;//document.title;
        document.title=urlTitle;
       //   console.log("window and dataLayer exist, pushing pageview event.");
         //   console.log(document.title)
    //  console.log(window.location.pathname + window.location.search);
          //https://www.bounteous.com/insights/2018/03/30/single-page-applications-google-analytics/
         // console.log( 'window.dataLayer')
         // console.log( window.dataLayer)
          let dataLayer = window.dataLayer || [];
            dataLayer.push({
             event: 'pageview',
             page: {
              path:urlPath,
              title: urlTitle
            }
          });
      } else {
          console.log("window or dataLater does not exist, cannot push pageview event.");
      }

      const getQueryString = url => { 
        const image = document.createElement('img');  
        var referrerMiniMe = document.referrer;
        image.height = 1;
        image.width = 1;
        image.src  = 'https://analyticsminimevzpr.azureedge.net/api/onepixel?code=M1rsfa4IR2vrGmonqDo0hFD5wffC3MAiISH0u4Qf5NLthz729h87Hw==&pk=activeresearch&referring_domain_querystring=' + encodeURIComponent(url) + '&referrerMiniMe='+referrerMiniMe;
        document.querySelector('body').appendChild(image);
       } 
       getQueryString(window.location); 

  }, 30);
};
 
firePageViewEvent();

 
 

//   console.log('Location changed ' + window.location.pathname);
//  console.log(document.title)
//  console.log(window.location.pathname + window.location.search);

  const   URLName  =window.location.pathname;  
    // var footerURLs = ["/invitations", "/myinvites", "/" ];
    // var n = footerURLs.includes("Mango"); 
     setStateA( "" )
    if(URLName === "/myprojects"  ){
      setStateA("myprojects" )
    }
    if(URLName === "/dataanalytics" ){ 
      setStateA( "Data analitycs" )
    }

    if(URLName === "/insights" ){ 
      setStateA( "insights" )
    }
    // if(URLName === "/invitations" ){ 
    //   setStateA( "invitations" )
    // }
   
    
    // if(URLName === "/accountinitialsetup" ){
    //   setStateA("accountinitialsetup" )
    // } 

}, [location]);


 
 
  return ( 
    (active === "home")?'':
    <BottomNavigation   style={{  zIndex:2147483647, backgroundColor:'#ffffff'}}
      value={value}
      onChange={(event, newValue) => { 
        setValue(newValue);
      }}
      showLabels
      //className={classes.stickToBottom}
      className="stickToBottom"
    >
      <BottomNavigationAction key="myprojects"  
    onClick={() => setActive( "myprojects" ) }
    className={(active === "search")? classes.selected :''} 
      label="My projects" component={Link} to={"/myprojects"} icon={<ListAltIcon />} />
       <BottomNavigationAction  key="dataanalytics" 
        className={(active === "dataanalytics")? classes.selected :''}  
        onClick={() => setActive( "dataanalytics")}
       label="Data analytics"  component={Link} to={"/dataanalytics"} icon={ <AnalyticsIcon />} />

      <BottomNavigationAction   key="insights" 
    onClick={() => setActive("insights")}  
    className={(active === "insights")? classes.selected :''}  
      label="Insights"   component={Link} to={"/insights"} icon={<BarChartIcon />} />
      {/* <BottomNavigationAction label="blobs"   component={Link} to={"/blobs"} icon={<BarChart />} /> */}
    
 
    </BottomNavigation> 
  );
}
